import { Link } from "react-router-dom";
import { Leaf, ArrowLeft } from "lucide-react";

/**
 * Shared layout for static legal pages (Privacy, Terms).
 * Keeps the InPalmo brand on top + a "Torna alla home" link, and gives a clean
 * vertical rhythm for long legal copy.
 */
export default function LegalPageLayout({ title, lastUpdate, children }) {
  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#1A1C19]">
      <header className="bg-[#FAF9F6]/85 backdrop-blur-md border-b border-[#E5E3DB] sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-xl bg-[#2E4A3B] text-white flex items-center justify-center">
              <Leaf size={18} className="text-[#A8D4B8]" />
            </div>
            <span
              className="text-lg font-semibold tracking-tight"
              style={{ fontFamily: "Work Sans, sans-serif" }}
            >
              In<span className="text-[#2E4A3B]">Palmo</span>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-[#4A524C] hover:text-[#2E4A3B] transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={14} />
            Torna alla home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1
          className="text-3xl sm:text-4xl font-semibold tracking-tight mb-2"
          style={{ fontFamily: "Work Sans, sans-serif" }}
        >
          {title}
        </h1>
        {lastUpdate && (
          <p className="text-sm text-[#8E918C] mb-10">Ultimo aggiornamento: {lastUpdate}</p>
        )}
        <div className="legal-content max-w-none space-y-5 text-[15px] text-[#4A524C] leading-relaxed">
          {children}
        </div>
      </main>

      <footer className="border-t border-[#E5E3DB] bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-[#8E918C]">
          <div>© {new Date().getFullYear()} InPalmo · Tutti i diritti riservati.</div>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-[#2E4A3B]">Privacy</Link>
            <Link to="/termini" className="hover:text-[#2E4A3B]">Termini</Link>
            <a href="mailto:ciao@inpalmo.it" className="hover:text-[#2E4A3B]">ciao@inpalmo.it</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
